module.exports = __webpack_public_path__ + "7805fc0e70d81ba38993557248afd293.svg";